/* ============================================================
   ai1-header-sticky.js - ALL IN 1 WORLD
   Added 2026-09-21. DRAFT THEME ONLY (167082754298).

   Three jobs, nothing else:
     1. On every template EXCEPT the homepage, mark the section wrapper
        around .ai1-chrome as the sticky host. That element is a child of
        <body> and therefore has the whole document to travel down, while
        .ai1-chrome itself is only ~136px tall and would drop the header
        off the top of the screen. The CSS also targets it with :has(), so
        this class is only the fallback for engines without :has().
     2. Publish the sticky ticker's real height as --ai1-tick-h so the
        homepage nav sticks directly underneath it instead of guessing an
        offset. Desktop only - at <=749px the ticker is not sticky (see the
        CSS, which uses the same breakpoint as the wishlist header layer in
        assets/ai1-wishlist.css) so the offset is 0.
     3. Toggle .is-stuck on .p-nav past the threshold. All of the visual
        change (text labels -> circular icons, brand compaction) lives in
        assets/ai1-header-sticky.css; this file never writes styles other
        than that one custom property.

   WHY IT RE-RESOLVES THE NAV ON shopify:section:load
   Observed in theme preview: the hot-reloader replaces the whole header
   section node after an asset change, which left this script holding a
   detached <nav> - it kept toggling .is-stuck on an element no longer in
   the document, so the visible header stayed in its top state no matter how
   far the page was scrolled. The theme editor replaces section nodes the
   same way. init() is therefore idempotent and re-runs on that event, while
   the window listeners are bound once.

   Deliberately NOT done here: no scroll library, no layout writes, no DOM
   restructuring, no cart / wishlist / search behaviour. The wishlist button
   is injected into .p-nav-acts by ai1-wishlist.js and is left alone. Reads
   are rAF-throttled and the scroll listener is passive.
   ============================================================ */
(function () {
  if (window.__ai1HeaderSticky) return;
  window.__ai1HeaderSticky = true;

  var THRESHOLD = 48;
  var MOBILE_MAX = 749;

  var nav = null;
  var tick = null;
  var stuck = false;
  var ticking = false;
  var bound = false;

  function measure() {
    var h = 0;
    if (tick && window.innerWidth > MOBILE_MAX) {
      try {
        if (window.getComputedStyle(tick).position === 'sticky') h = tick.offsetHeight;
      } catch (e) { h = 0; }
    }
    document.documentElement.style.setProperty('--ai1-tick-h', h + 'px');
  }

  function read() {
    ticking = false;
    if (!nav || !document.contains(nav)) { init(); if (!nav) return; }
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var next = y > THRESHOLD;
    if (next !== stuck || next !== nav.classList.contains('is-stuck')) {
      stuck = next;
      nav.classList.toggle('is-stuck', stuck);
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(read); }
  }

  function init() {
    var found = document.querySelector('#ai1-wrap .p-nav, .ai1-chrome .p-nav');
    if (!found) return;
    nav = found;

    var chrome = nav.closest ? nav.closest('.ai1-chrome') : null;
    if (chrome) {
      var host = chrome.closest('.shopify-section');
      if (host) host.classList.add('ai1-hdr-host');
    }

    tick = document.querySelector('#ai1-wrap .p-tick, .ai1-chrome .p-tick');
    stuck = false;
    measure();
    read();

    if (!bound) {
      bound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', measure, { passive: true });
    }
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
